module.exports = __webpack_public_path__ + "media/images/help/submission-management-check-submission-c9d478a52296bf5b9b6454e13cc86d3e.png";